export enum PaymentStatus {
  INITIATED = 'INITIATED',
  AWAITING_ADDITIONAL_SIGNATURE = 'AWAITING_ADDITIONAL_SIGNATURE',
  AUTHORIZED = 'AUTHORIZED',
  CANCELLED = 'CANCELLED',
  PARTIALLY_CAPTURED = 'PARTIALLY_CAPTURED',
  FULLY_CAPTURED = 'FULLY_CAPTURED',
  FULLY_REFUNDED = 'FULLY_REFUNDED',
  REFUND_INITIATED = 'REFUND_INITIATED',
  REFUND_FAILED = 'REFUND_FAILED',
}
